// @ts-nocheck
import { StepLabel, StepConnector, Theme, Step } from "@material-ui/core";
import { createStyles, makeStyles, withStyles } from "@material-ui/styles";

const drawerWidth = 240;

export const ColorlibConnector = withStyles(() => ({
  alternativeLabel: {
    top: 48,
    left: "calc(-50% + -40px)",
    right: "calc(50% + -40px)",
    display: "none"
  },
  active: {
    "& $line": {
      borderColor: "#54A4A6"
    },
    left: "calc(-50% + -5px)",
    right: "calc(50% + -5px)"
  },
  completed: {
    "& $line": {
      borderColor: "#54A4A6"
    }
  },
  line: {
    borderColor: "#54A4A6",
    borderTopWidth: 3,
    borderRadius: 1
  }
}))(StepConnector);

export const ColorStepLabel = withStyles((theme: Theme) => ({
  label: {
    cursor: "pointer",
    fontSize: "1.2rem",
    [theme.breakpoints.down("lg")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem"
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.6rem"
    },
    color: "#54A4A6",
    paddingBottom: "1rem",
    borderBottom: "0.3125rem solid #AAAAAA",
    textTransform: "capitalize",
    width: "100%",
    transition: "all 200ms ease"
  },
  active: {
    color: "#54A4A6!important",
    fontWeight: "bold!important",
    paddingBottom: "1rem",
    borderBottom: "0.3125rem solid #54A4A6",
    borderImage:
      "linear-gradient(to left, #AAAAAA 0%, #AAAAAA 50%, #54A4A6 50%, #54A4A6 100%) 1",
    textTransform: "capitalize",
    fontSize: "1.2rem",
    [theme.breakpoints.down("lg")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem"
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.6rem"
    }
  },
  completed: {
    color: `${theme.palette.primary.light}!important`,
    fontWeight: "bold!important",
    paddingBottom: "1rem",
    borderBottom: "0.3125rem solid #54A4A6!important",
    // borderImage: "linear-gradient(to left, #AAAAAA 0%, #AAAAAA 50%, #54A4A6 50%, #54A4A6 100%) 1",
    textTransform: "capitalize",
    fontSize: "1.2rem",
    [theme.breakpoints.down("lg")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.7rem"
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.6rem"
    }
  }
}))(StepLabel);

export const useColorlibStepIconStyles = makeStyles((theme: Theme) => ({
  root: {
    cursor: "pointer",
    zIndex: 1,
    width: "1.7rem",
    height: "1.7rem",
    border: "1px solid #54A4A6",
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#FAF0FC",
    position: "absolute",
    bottom: "-5px",
    right: "calc(50% - 0.5rem)",
    [theme.breakpoints.down("md")]: {
      bottom: "-7px"
    },
    [theme.breakpoints.up("lg")]: {
      bottom: "-9px"
    }
  },
  active: {
    border: "1px solid #fff",
    backgroundColor: "#54A4A6",
    width: "1.7rem",
    height: "1.7rem",
    right: "calc(50% - 0.625rem)",
    bottom: "-5px",
    color: "#fff",
    [theme.breakpoints.down("md")]: {
      bottom: "-7px"
    },
    [theme.breakpoints.up("lg")]: {
      bottom: "-9px"
    }
  },
  completed: {
    backgroundColor: "#54A4A6",
    border: "1px solid #fff",
    display: "flex",
    width: "1.7rem",
    height: "1.7rem",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    bottom: "-5px",
    color: "#fff",
    right: "calc(50% - 0.5rem)",
    [theme.breakpoints.down("md")]: {
      bottom: "-7px"
    },
    [theme.breakpoints.up("lg")]: {
      bottom: "-9px"
    }
  }
}));

export const ColorStep = withStyles(() => {
  return {
    horizontal: {
      paddingLeft: 0,
      paddingRight: 0
    }
  };
})(Step);

export default withStyles(
  theme =>
    createStyles({
      root: {
        "&::-webkit-scrollbar": {
          width: "10px"
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#F4F4F6",
          borderRadius: theme.spacing(1)
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#BBBEC6",
          borderRadius: theme.spacing(1)
        }
      },
      rootChildContainer: {
        margin: "1.5rem 2rem 2rem 2rem"
      },
      rootChildContainerpdf: {},
      sideBar: {
        position: "relative",
        backgroundColor: "#ffffff",
        margin: "0 2rem"
      },
      toggleSideBarButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        height: theme.spacing(5),
        width: theme.spacing(5),
        borderRadius: "10px",
        backgroundColor: theme.palette.primary.main,
        right: "-10px",
        top: "29%",
        color: "#fff"
      },
      toggleSideBarButton2: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        height: theme.spacing(5),
        width: theme.spacing(5),
        borderTopRightRadius: "10px",
        borderBottomRightRadius: "10px",
        backgroundColor: theme.palette.primary.main,
        left: "-10px",
        top: "29%",
        color: "#fff"
      },
      navButton: {
        zIndex: 1,
        position: "absolute",
        right: 0,
        top: "50%",
        color: "black"
      },
      appBar: {
        width: "100%",
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
        backgroundColor: " #ffffff",
        height: "10vh"
      },
      toolbarLogo: {
        flexGrow: 1
      },
      stepperContentClass: {
        padding: theme.spacing(1, 0),
        borderLeft: `3px solid #eaeaf0`,
        marginLeft: "50px"
      },
      packageName: {
        fontFamily: "Lato",
        fontSize: "1rem",
        fontWeight: "bold",
        color: theme.palette.common.white,
        textAlign: "center",
        marginLeft: "1rem"
      },
      drawer: {
        [theme.breakpoints.up("sm")]: {
          width: drawerWidth,
          flexShrink: 0
        }
      },
      menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
          display: "none"
        }
      },
      toolbar: theme.mixins.toolbar,
      drawerPaper: {
        width: drawerWidth
      },
      content: {
        flexGrow: 1,
        padding: theme.spacing(3)
      },
      closeMenuButton: {
        marginRight: "auto",
        marginLeft: 0
      },
      hiddenClass: {
        width: "100%"
      },
      packageCardStyles: {
        flexGrow: 0,
        flexBasis: "31%",
        maxWidth: "31%",
        marginRight: "1.5%",
        cursor: "pointer",
        borderRadius: "4px",
        position: "relative",
        backgroundColor: theme.palette.primary.main,
        padding: "0.5rem 0"
      },
      crossOverImage: {
        right: "-5px",
        top: "-5px",
        position: "absolute",
        backgroundColor: "red",
        color: "white",
        padding: "3px",
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        cursor: "pointer"
      }
    }),
  { withTheme: true }
);
